"use strict";

exports.__esModule = true;
exports.breakpoints = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var utils = _interopRequireWildcard(require("../../shared"));

var _variables = require("../../shared/designtokens/_variables.es6");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable-next-line no-unused-vars */
// components to display only when a specific breakpoint is active on the browser
var breakpoints = {
  xs: {
    max: _variables.GridBreakpointXsMax
  },
  sm: {
    min: _variables.GridBreakpointSmMin,
    max: _variables.GridBreakpointSmMax
  },
  md: {
    min: _variables.GridBreakpointMdMin,
    max: _variables.GridBreakpointMdMax
  },
  lg: {
    min: _variables.GridBreakpointLgMin
  }
};
exports.breakpoints = breakpoints;

function Responsive(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      children = _ref.children;
  // if there are at least 2 breakpoints, find smallest and largest
  var smallest = xs && 'xs' || sm && 'sm' || md && 'md' || lg && 'lg';
  var largest = lg && 'lg' || md && 'md' || sm && 'sm' || xs && 'xs';
  var mediaQueryProps = {}; // set minWidth/maxWidth based on which breakpoints were passed in

  if (smallest && largest && smallest !== largest) {
    if (breakpoints[smallest] && breakpoints[smallest].min) {
      mediaQueryProps.minWidth = breakpoints[smallest].min;
    }

    if (breakpoints[largest] && breakpoints[largest].max) {
      mediaQueryProps.maxWidth = breakpoints[largest].max;
    }
  } else if (smallest) {
    if (breakpoints[smallest] && breakpoints[smallest].max) {
      mediaQueryProps.maxWidth = breakpoints[smallest].max;
    }

    if (breakpoints[smallest] && breakpoints[smallest].min) {
      mediaQueryProps.minWidth = breakpoints[smallest].min;
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], mediaQueryProps, children);
}

Responsive.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false
};
Responsive.propTypes = {
  /** Whether to display in XS breakpoint */
  xs: _propTypes["default"].bool,

  /** Whether to display in SM breakpoint */
  sm: _propTypes["default"].bool,

  /** Whether to display in MD breakpoint */
  md: _propTypes["default"].bool,

  /** Whether to display in LG breakpoint */
  lg: _propTypes["default"].bool,

  /** content to render, can be function if we need access to breakpoint  */
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].node]).isRequired
};
var _default = Responsive;
exports["default"] = _default;